import React from "react";
import PropTypes from "prop-types";

const SizeColumnsEvenlyIcon = ({
  width,
  size,
  height,
  style,
  color,
  noPointer,
  ...props
}) => (
  <svg
    {...props}
    data-no-pointer={noPointer}
    width={width || size || 20}
    height={height || size || 20}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h20v20H0z" />
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M10 3h7v2h-7zm0 6h7v2h-7zm0 6h7v2h-7zM4 3v13M2 5l2-2 2 2M2 15l2 2 2-2"
      />
    </g>
  </svg>
);

SizeColumnsEvenlyIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default SizeColumnsEvenlyIcon;
